import { render, staticRenderFns } from "./org-single-details.vue?vue&type=template&id=562baa27&"
import script from "./org-single-details.vue?vue&type=script&lang=js&"
export * from "./org-single-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports